import { createEffect } from "effector";
import { getWashingTypesByStation, sendReceipt } from "../../services/washingService";
import { AppError } from "../../services/classes";
import { Receipt, WashingOption } from "../../types/washing.types";

export const fetchWashingMachinesEffect = createEffect<string, WashingOption[], AppError>(async (station: string) => {
  return await getWashingTypesByStation(station);
});

export const sendReceiptEffect = createEffect<Receipt, void, AppError>(async (receipt: Receipt) => {
  const response = await sendReceipt(receipt);
  return response;
});
